export const RECEIVE_USER_COURSES = 'RECEIVE_USER_COURSES';
